export enum NudgeScheduleType {
  RECURRING = 'recurring',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  ONE_TIME = 'one_time',
}

export interface Nudge {
  cron_expression: string
  cron_job_id: number
  nudge_category: NudgeCategory
  id: number
  nudge_time: string
  nudge_type: NudgeType
  is_active: boolean
  is_enabled: boolean
  org_id: string
  time_zone: string
  chatbot_id?: string
  chatbot_name?: string
  chatbot_code?: string
  schedule_type: NudgeScheduleType
  nudge_date?: string  // ISO date string, e.g. "2025-04-12"
  day_of_week?: number  // 0=Sunday ... 6=Saturday, set when schedule_type=weekly
  day_of_month?: number // 1-31, set when schedule_type=monthly
  follow_up_enabled?: boolean // send daily follow-up reminders until end of week/month
}

export enum NudgeType {
  SEND_SUMMARY_REPORT = 'send_summary_report',
  SEND_TASK_REMINDER = 'send_task_reminder',
}

export enum NudgeCategory {
  ORG = 'org',
  Chatbot = 'chatbot',
}

export interface CreateNudgeDto {
  nudge_type: NudgeType;
  time_zone: string;
  nudge_time: string;
  nudge_category: NudgeCategory;
  schedule_type: NudgeScheduleType;
  nudge_date?: string;
  day_of_week?: number;
  day_of_month?: number;
  follow_up_enabled?: boolean;
}

export interface UpdateNudgeDto {
  nudge_type?: NudgeType;
  time_zone?: string;
  nudge_time?: string;
  nudge_category?: NudgeCategory;
  schedule_type: NudgeScheduleType;
  nudge_date?: string;
  day_of_week?: number;
  day_of_month?: number;
  follow_up_enabled?: boolean;
}

export interface EventFilters {
  org_id: string;
  chatbot_id?: string;
  nudge_category?: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}
